export default __webpack_public_path__ + "static/4-14635da6b705e68fcc71986ab0dd1f47.jpeg";